// @flow
import React from 'react';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';

// Components
import { TextField } from 'components/api';
import { Icon } from 'components/atoms/Icon/';

import './PasswordField.scss';

type Props = {
  className?: string,
  intl: Object
};

type State = {
  type: 'password' | 'text'
};

class PasswordField extends React.Component<Props, State> {
  static block = 'password-field';
  static inputPasswordType = 'password';
  static inputTextType = 'text';

  state = {
    type: PasswordField.inputPasswordType
  };

  showHidePassword(show: boolean = true) {
    this.setState({
      type: show ? PasswordField.inputTextType : PasswordField.inputPasswordType
    });
  }

  render() {
    const { type } = this.state;
    const { className, intl, ...other } = this.props;
    const ns = PasswordField.block;
    const classProps = classNames(ns, className);
    return (
      <div className={classProps}>
        <TextField className={`${ns}__input`} {...other} type={type} />
        <div className={`${ns}__icon-wrapper`}>
          <Icon
            className={`${ns}__icon`}
            type="eye"
            onMouseDown={() => this.showHidePassword()}
            onMouseUp={() => this.showHidePassword(false)}
            onMouseOut={() => this.showHidePassword(false)}
            onTouchStart={() => this.showHidePassword()}
            onTouchEnd={() => this.showHidePassword(false)}
            onTouchCancel={() => this.showHidePassword(false)}
            tabIndex={0}
            aria-label={intl.formatMessage({
              id: 'c8.aria.show.password',
              defaultMessage: 'Show password'
            })}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(PasswordField);



// WEBPACK FOOTER //
// ./src/components/api/components/PasswordField/PasswordField.js